import Title from 'antd/es/typography/Title';

export default function Unauthorized() {
    return (
        <Title>Usuário não autorizado.</Title>
    )
}
